import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form, Icon, Input, Button, Row, Col, Spin, message } from 'antd';

const FormItem = Form.Item;

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };
  }
  componentWillMount() {
    window.scrollTo({ top: 0 });
  }
  componentWillReceiveProps(nextProps) {
    const { authError, authSuccess, loading } = nextProps.localAuth;

    // if (authSuccess && !loading) message.success(authSuccess);
    if (authError && !loading) message.error(authError);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  
  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.signIn(this.state);
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.props.localAuth;
    return (
      <Row>
        <Col
          xs={{ span: 22, offset:1 }}
          sm={{ span: 22, offset:1 }}
          md={{ span: 10, offset: 6 }}
          lg={{ span: 10, offset: 7 }}
        >
            <section className="signinModel fadeInUp animated">
              {/* <div className="signin-header">Log In to your account</div> */}
              <div className="signin-body">
          <Spin  indicator={<Icon type="loading" style={{ fontSize: 60 }} spin /> } spinning={loading}>

                <Form
                  onSubmit={e => this.handleSubmit(e)}
                  className="login-form"
                >
                  <div className="xheader">
            <img src="../../img/logo.png" />

                  <h5>Sign in to continue</h5>
                  </div>
                  <FormItem>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your email'
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid email'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="mail"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="email"
                        placeholder="Email"
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password'
                        }
                      ]
                    })(
                      <Input.Password
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="lock"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        type="password"
                        name="password"
                        placeholder="Password"
                      />
                    )}
                  </FormItem>
                  <FormItem className="login-btn">
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      className="login-form-button xpad-btn"
                    >
                      Log in
                    </Button>
                  </FormItem>
                  <div className="signin-footer"><hr />
                  Forgot password? <Link to="/forgot-password">Click here</Link>
              <br />  Don't have an account? <Link to="/signup" className="link">Signup</Link>{' '}

              </div>
                </Form>
          </Spin>
              </div>
             `
            </section>
        </Col>
      </Row>
    );
  }
}
const WrappedSigninForm = Form.create()(Signin);
export default WrappedSigninForm;
